import { FC } from 'react'
import { BadgeProps, Badge } from '../Badge'
import { MdOutlineElectricBolt } from 'react-icons/md'

export type BadgePrimeProps = Omit<
  BadgeProps,
  'type' | 'variant' | 'customColors' | 'leftIcon' | 'rightIcon'
>

export const BadgePrime: FC<BadgePrimeProps> = ({ value, ...restProps }) => {
  return (
    <Badge
      {...restProps}
      leftIcon={
        <MdOutlineElectricBolt className="text-white min-w-[14px] min-h-[14px]" />
      }
      value={value}
      customColors={{
        bgColor: 'bg-notif-yellow',
        textColor: 'text-white'
      }}
    />
  )
}

export default BadgePrime
